import React, { useState } from 'react';
import { Button, Modal } from 'antd';

const DetailRulePopup: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button
                onClick={showModal}
                style={{
                    background: 'linear-gradient(264.28deg, #ffc7c7 -38.2%, #fe2727 103.12%)',
                    fontFamily: 'conthrax',
                    color: 'white',
                    border: 'none',
                }}>
                Chi tiết
            </Button>
            <Modal
                title="Thể Lệ"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <div style={{
                    height: '70vh',
                    overflowY: 'scroll',
                }}>
                    <h2>Tiêu chí chấm điểm Vòng Sơ Loại và Bán Kết:</h2>
                    <h3>Nội dung</h3>

                    <p>Phần phát triển bài nói bao gồm cấu trúc bài nói, cách sắp xếp nội dung, những tài liệu hỗ trợ phát triển bài nói.</p>

                    <p>Một bài phát biểu được đánh giá tốt sẽ bao gồm các tiêu chí sau đây:</p>
                    <p>Dễ hiểu.</p>
                    <p>Có luận điểm chính, mục tiêu bài nói rõ ràng.</p>
                    <p>Có đầy đủ cấu trúc: mở đầu, nội dung chính và phần kết thúc.</p>
                    <p>Thu hút: thu hút sự chú ý của khán giả và hướng họ đến mục tiêu mà bài nói muốn trình bày.</p>
                    <p>Có sử dụng những dẫn chứng cụ thể để hỗ trợ bài nói.</p>
                    <p>Không sáng tạo vượt quá 70% phạm vi chủ đề xuyên suốt của cuộc thi.</p>

                    <p>Xác định rõ chủ đề bài nói có phù hợp với đối tượng cụ thể nào?</p>

                    <h3><b>Truyền tải</b></h3>

                    <p>Phần thể hiện trước ống kính</p>

                    <p>Ăn mặc phù hợp, chỉn chu.</p>
                    <p>Ngôn ngữ cơ thể phù hợp để hỗ trợ lời bài nói thông qua cử chỉ, biểu cảm và tư thế.</p>
                    <p>Thể hiện được sự nhiệt tình và tự tin.</p>
                    <p>Giọng nói.</p>
                    <p>Cường độ, tốc độ nói và âm thanh giọng nói lên xuống phù hợp làm tăng thêm sự phong phú của bài nói.</p>
                    <p>Từ ngữ dễ nghe và dễ hiểu.</p>

                    <p>III. Ngôn ngữ sử dụng</p>

                    <p>1. Lựa chọn từ ngữ phù hợp với người nghe.</p>
                    <p>2. Từ ngữ được sử dụng chính xác và thể hiện sự hiểu biết rõ ràng về suy nghĩ muốn truyền đạt.</p>
                    <p>3. Sử dụng từ ngữ đúng về mặt ngữ pháp và phát âm.</p>
                    <p>4. Người nói sử dụng ít hoặc không sử dụng từ đệm thể hiện khả năng sử dụng ngôn ngữ lưu loát.</p>

                    <p>Cách tính điểm Vòng Bán Kết và Giải Thưởng Thí Sinh Được Yêu Thích Nhất</p>
                    <p>Các thí sinh lọt vào Vòng Bán Kết sẽ được quay video dự thi tại trường Đại học FPT thành phố Hồ Chí Minh bởi ekip của Ban Tổ Chức.</p>
                    <p>Tất cả các video dự thi của TOP 30 sẽ được đăng tải trên fanpage của Câu Lạc Bộ Kỹ Năng và Tiếng Anh - Skillcetera.</p>
                    <p>Hình thức tính điểm như sau:</p>
                    <p>Bước 1: Khán giả tham gia bình chọn phải thực hiện like fanpage của Câu Lạc Bộ Kỹ Năng và Tiếng Anh - Skillcetera.</p>
                    <p>Bước 2: Tiến hành thả cảm xúc, bình luận và chia sẻ bài viết về trang cá nhân của mình ở chế độ công khai.</p>
                    <p>Bước 3: Điểm sẽ được tính dựa trên LƯỢT TIẾP CẬN của bài viết.</p>
                    <p>1000 LƯỢT TIẾP CẬN = 1 ĐIỂM</p>

                    <p>
                        Lưu ý:
                        Không giới hạn SỐ ĐIỂM, thí sinh được nhiều điểm nhất sẽ nhận được Giải Thưởng Thí Sinh Được Yêu Thích Nhất.
                        Lượt tiếp cận cho bài thi của thí sinh tham gia dự thi sẽ phụ thuộc vào lượng cảm xúc, bình luận và chia sẻ.
                        Tuy nhiên số lượng chia sẻ sẽ có phần ảnh hưởng nhất trong việc thúc đẩy lượt tiếp cận bài viết của thí sinh.
                        Phần thi này chỉ chiếm 30% SỐ ĐIỂM quyết định Để đảm bảo tính công bằng và minh bạch nên kết quả về
                        LƯỢT TIẾP CẬN sẽ được Ban Tổ Chức trích xuất data từ Meta Business Suite của fanpage Skillcetera cho từng thí sinh.
                    </p>

                    <p style={{
                        color: 'red',
                    }}>TOP 10 phần thi xuất sắc nhất ở Vòng Bán Kết sẽ lọt vào Vòng Chung Kết của cuộc thi.</p>
                </div>
            </Modal>
        </>
    );
};

export default DetailRulePopup;